<template>
  <div>
    <b-row>
      <b-col>
        <h4>Tuỳ chọn sản phẩm</h4>
      </b-col>
      <b-col>
        <div class="justify-content-end" style="text-align: end">
          <div class="mb-5">
            <b-button
              class="btn btn-primary font-weight-bolder btn-sm button"
              @click="$emit('add-option')"
            >
              <i style="font-size: 1rem" class="flaticon2-add-1"></i>Thêm mới
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
    <ProductOptions
      ref="productOptions"
      :existingOptions.sync="options"
      @update:options="updateOptions"
    />
  </div>
</template>

<script>
import ProductOptions from '@/view/pages/products/ProductOptions.vue';

export default {
  name: 'ProductOptionsSection',
  components: {
    ProductOptions,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    updateOptions(options) {
      this.$emit('update:options', options);
    },
    addNewOption() {
      if (this.$refs.productOptions) {
        this.$refs.productOptions.addNewOption();
      }
    },
  },
};
</script>
